export default "__VITE_ASSET__Bq2Qygga__"